import InputPhone from './InputPhone'

export default InputPhone